import React, { useState, createContext } from 'react';
export const PageContext = createContext();

export const StepProvider = ({ children }) => {
  const [currPage, setCurrPage] = useState(0);
  const [pageHistory, setPageHistory] = useState([0]);

  const goToPage = (page) => {
    setPageHistory(prevHistory => [...prevHistory, currPage]);
    setCurrPage(page);
  };

  const goNext = () => {
    setPageHistory(prevHistory => {
      const newHistory = [...prevHistory];
      newHistory.push(currPage);
      setCurrPage(currPage + 1);
      return newHistory;
    });
  };

  const goBack = () => {
    setPageHistory(prevHistory => {
      const newHistory = [...prevHistory];
      const prevPage = newHistory.pop();
      setCurrPage(prevPage);
      return newHistory;
    });
  };

  const resetPageContext = () => {
    setCurrPage(0);
    setPageHistory([0]);
  };

  return (
      <PageContext.Provider value={{ currPage, goBack, goToPage, goNext, pageHistory, resetPageContext }}>
        {children}
      </PageContext.Provider>
  );
};